import { connect } from 'react-redux';

import { getIsWishlistAvailable } from 'src/store/menu/selectors';
import { getIsMobile, getIsWebview } from 'src/store/view/selectors';

import { getRatingsBadgeListHotel } from 'src/store/hotelRating/selectors';
import { isSSR } from 'src/helpers/ssr';
import {
  getHotelId,
  getHotelStars,
  getInitialPrice,
  getHotelShortInfo,
  getHotelRoulette,
  getHotelTitle,
} from 'src/routes/Hotel/store/hotel';
import { getBreadcrumbs } from '../../store/selectors/breadcrumbs';

import Header from '../../components/Header';
import { getDefaultPrice } from '../../store/selectors/common';

const mapStateToProps = (state) => {
  const isRoulette = getHotelRoulette(state);
  return {
    title: getHotelTitle(state),
    price: isSSR ? getInitialPrice(state) : getDefaultPrice(state),
    stars: getHotelStars(state),
    breadcrumbs: getBreadcrumbs(state),
    subheader: isRoulette ? null : getHotelShortInfo(state),
    isMobile: getIsMobile(state),
    isWebview: getIsWebview(state),
    badgeList: getRatingsBadgeListHotel(state),
    isWishlistAvailable: getIsWishlistAvailable(state),
    hotelId: getHotelId(state),
  };
};

export default connect(mapStateToProps)(Header);
